import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { trackPageViewFromTransition } from 'sh-www/utils/datalayer';
import { EMBER_ROUTE_NAMES } from 'sh-www/constants/routes';

class AdminRoute extends Route {
  @service router;
  @service session;

  redirect() {
    const { isAuthenticated, currentUser } = this.session;

    if (!isAuthenticated || !currentUser) {
      this.router.transitionTo(EMBER_ROUTE_NAMES.SIGNIN);
    } else if (!currentUser.isAdmin) {
      this.router.transitionTo(EMBER_ROUTE_NAMES.SIGNOUT);
    }
  }

  activate(transition) {
    super.activate(...arguments);

    trackPageViewFromTransition(this, transition, '/admin/', (url) => {
      url.pathname = '/admin';
      url.search = '';
      url.hash = '';
    });
  }
}

export default AdminRoute;
